import { lazy } from 'react';
export const lazyWithRetry = (componentImport) => lazy(async () => {
    const pageHasBeenForceRefreshed = JSON.parse(window.localStorage.getItem('page-has-been-force-refreshed') || 'false');
    try {
        const component = await componentImport();
        if (pageHasBeenForceRefreshed) {
            // If the page has been force-refreshed before, reset the flag
            window.localStorage.setItem('page-has-been-force-refreshed', 'false');
        }
        return component;
    }
    catch (error) {
        if ((isChunkLoadError(error) || isInteractionRequiredAuthError(error)) && !pageHasBeenForceRefreshed) {
            // If the error is a ChunkLoadError and the page hasn't 
            // been force-refreshed before, do it now
            await forcePageRefresh();
            window.localStorage.setItem('page-has-been-force-refreshed', 'true');
            return window.location.reload();
        }
        // If the error is not a ChunkLoadError or the page has 
        // already been force-refreshed and still fails, raise the error
        throw error;
    }
});
async function forcePageRefresh() {
    // Clear all cache
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((name) => caches.delete(name)));
}
function isChunkLoadError(error) {
    return (error instanceof Error &&
        error.name === 'ChunkLoadError' &&
        error.message.includes('Loading chunk'));
}
function isInteractionRequiredAuthError(error) {
    return (error instanceof Error &&
        error.name === 'InteractionRequiredAuthError' &&
        error.message.includes("User does not have an existing session"));
}
